"use client";

// Högtidsteman on screen (lib/hogtider.ts): today's holiday effect, when the
// account setting is on, the page is not an exam/diagnosis/projector view and
// the device is not a phone or set to reduce motion. Purely client-side: no
// network, no server state; the layer itself never takes the pointer.

import { usePathname } from "next/navigation";
import { arHogtidUndantag } from "@/lib/hogtider";
import { useHogtid } from "@/lib/hogtid";
import Fallande from "./Fallande";
import Kycklingar from "./Kycklingar";
import Spindlar from "./Spindlar";
import { useRorelseTillaten } from "./useRorelseTillaten";
import styles from "./hogtid.module.css";

export default function HogtidLager() {
  const vag = usePathname() ?? "/";
  const { pa, hogtid } = useHogtid();
  const rorelse = useRorelseTillaten();
  if (!pa || !hogtid || !rorelse || arHogtidUndantag(vag)) return null;
  return (
    <div className={styles.lager} aria-hidden="true" data-hogtid={hogtid.id}>
      {hogtid.effekt === "spindlar" ? (
        <Spindlar />
      ) : hogtid.effekt === "kycklingar" ? (
        <Kycklingar />
      ) : (
        <Fallande key={hogtid.id} effekt={hogtid.effekt} />
      )}
    </div>
  );
}
